export async function lookupWord(word) {
  try {
    const res = await fetch(`/api/jisho?keyword=${encodeURIComponent(word)}`);
    if (!res.ok) return null;
    const data = await res.json();
    return data.data?.[0] || null;
  } catch {
    return 'offline';
  }
}
